<template>
  <table class="table table-condensed">
    <thead>
      <tr>
        <th>Nom</th>
        <th>Description</th>
        <th
          class="text-center"
          v-if="hasPermission($store.state.user, 'SETTINGS_CONCEPT_WRITE')"
        >
          Archive
        </th>
      </tr>
    </thead>
    <tbody v-if="concepts.length > 0">
      <tr
        v-for="(concept, index) in concepts"
        :key="index"
        @click="goToConcept(concept)"
        class="click"
      >
        <td>{{ concept.name }}</td>
        <td>{{ concept.description }}</td>
        <td
          class="text-center"
          v-if="hasPermission($store.state.user, 'SETTINGS_CONCEPT_WRITE')"
        >
          <button
            type="button"
            :class="`btn btn-sm ${
              concept.archived ? 'btn-outline-primary' : 'btn-primary'
            }`"
            :disabled="archiving === concept.name"
            :title="concept.archived ? 'Restaurer' : 'Archiver'"
            v-tooltip="{ content: concept.archived ? 'Restaurer' : 'Archiver' }"
            @click.stop="toggleArchive(concept)"
          >
            <i :class="concept.archived ? 'fa fa-undo' : 'fa fa-archive'"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    concepts: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      archiving: null,
    };
  },

  methods: {
    goToConcept(concept) {
      this.$router.push({
        name: "concept-details",
        params: {
          id: concept.id,
        },
      });
    },

    toggleArchive(concept) {
      this.$confirm({
        message: !concept.archived
          ? `Êtes-vous sûr de vouloir archiver le concept "${concept.name}" ?`
          : `Êtes-vous sûr de vouloir restaurer le concept "${concept.name}" ?`,
        onConfirm: async () => {
          this.archiving = concept.name;

          try {
            const { data } = await this.$api.put("/concepts", {
              name: concept.name,
              archived: !concept.archived,
            });

            this.$emit("updated", data);
          } catch {
            this.$errorToast(
              !concept.archived
                ? "Impossible d'archiver le concept"
                : "Impossible de restaurer le concept",
            );
          } finally {
            this.archiving = null;
          }
        },
      });
    },
  },
};
</script>
